<div class="closeButton" >
    <button mat-icon-button [mat-dialog-close]="true">
        <mat-icon>close</mat-icon>
    </button>
</div>
<form #f="ngForm" (ngSubmit)="onSubmitSuche(f.suche)">
  <mat-form-field class="filterFollowingUserInput" >
      <div matSuffix>
          <mat-icon>search</mat-icon>
      </div>
    <input matInput
           placeholder="{{'keyword_$426' | translate}}"
           [(ngModel)]="value"
           #searchbox
           (onchange)="_filterLen(value)"
           autocomplete="off"
           [formControl]="searchValue">
           <mat-hint align="start"> <strong>{{friendsListLength}}</strong> {{'keyword_$425' | translate}} </mat-hint>
  </mat-form-field>
</form>
<br>
<div class="followerList" *ngFor="let friend of filteredStates | async">
    <mat-card>
        <mat-card-header>
            <div mat-card-avatar (click)="closeBottomSheet()" routerLink="p/{{friend.user_name}}" class="followerListUserAvatar" [ngStyle]="{'background': 'linear-gradient(0deg, rgba(0, 0, 0, 0.5),
            rgba(0, 0, 0, 0.5)), url(' + friend.user_avatar + ')
            center center / cover no-repeat'}">
            </div>
            <mat-card-title>{{friend.user_name}}

            </mat-card-title>
            <mat-card-subtitle *ngIf="friend.user_city != null"> {{'keyword_$218' | translate}} {{friend.user_city}}</mat-card-subtitle>
            <mat-card-subtitle *ngIf="friend.user_city == null"> {{'keyword_$238' | translate}} </mat-card-subtitle>
            <span class="example-fill-remaining-space"></span>
            <!-- <button mat-icon-button color="warn" (click)="deleteRelationRequest(friend.user_id)">
                <mat-icon>person_remove</mat-icon>
            </button> -->
            <button mat-icon-button color="primary" routerLink="p/{{friend.user_name}}" (click)="closeBottomSheet()">
                <mat-icon>navigate_next</mat-icon>
            </button>
        </mat-card-header>
    </mat-card>
</div>
